import { Component, ElementRef, Inject } from '@angular/core';
import { EventBus, RoutingService } from '@skylab-angular-shared/core';
import { EventBusBase } from '@skylab-shared/core';
import { MenuComponentBase } from '../menu-base.component';
import { MenuItemSubComponent } from '../menu-item-sub/menu-item-sub.component';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
    selector: 'skl-menu-context',
    templateUrl: './menu-context.component.html',
    imports: [MenuItemSubComponent, MenuItemComponent]
})
export class MenuContextComponent extends MenuComponentBase {
    public constructor(
        elRef: ElementRef,
        routingService: RoutingService,
        @Inject(EventBus) eventBus: EventBusBase) {
        super(elRef, eventBus, routingService);
    }
}
